import Swal from "sweetalert2";

//Possible Types: [success, error, warning, info, question]
//Usage --> //showToast('success', 'Hogya')
export const showToast = (type, message) => {
    Swal.fire({
        icon: type,
        title: message,
        showConfirmButton: false,
        timerProgressBar: true,
        timer: 3000,
        customClass: {
            popup: 'swal-toast-style'
        }
    });
};

export const showConfirmMessage = async (data) => {
    const confirmed = await Swal.fire({
        title: 'Confirmation',
        text:  data?.text ? data?.text : 'Are you sure you want to Delete it?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: data?.confirmButtonText ? data?.confirmButtonText :'Yes Delete it!',
        cancelButtonText: 'No',
        customClass: {
            popup: 'swal-toast-style'
        }
    });
    return confirmed.isConfirmed;
};

export const showTokenExpiryPopUp = async () =>{
    const Confirmation = await Swal.fire({
        title: 'Timeout',
        text: 'Session expired. Please log in again',
        icon: 'warning',
        showCancelButton: false,
        allowEscapeKey: false,
        allowOutsideClick:false,
        allowEnterKey:false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Logout Now',
        customClass: {
            popup: 'swal-toast-style'
        }
    })
    return Confirmation.isConfirmed;
}


//Usage --> Toast.fire({ icon: 'success', title:"xx", customClass: {popup: 'custom-toast-class' }});
export const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 2000,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
    }
});


//Usage --> setAlertData({ type: "success", message: res.msg }); // and state bnaoo bhaii const [alertData, setAlertData] = useState(null);
const iconMap = {success: "feather-check-circle", danger: "feather-alert-octagon", warning: "feather-alert-triangle", info: "feather-info",};
export const ShowAlert = ({ type = "info", text = "" }) => {
  const icon = iconMap[type] || iconMap.info;
  return (
    <div className={`alert alert-${type} d-flex align-items-center`} role="alert">
      <i className={`${icon} flex-shrink-0 me-2`} />
      <div>{text}</div>
    </div>
  );
};